/* eslint-disable @typescript-eslint/no-use-before-define */
import { isNumber } from 'lodash'
import kmeans from 'utils/kmeans'
import { ChartConfig, Datum } from '../types'
import { isValidNumber } from '../charts/share/utils'

export const PERCENT_BREAK_THRESHOLD = 0.25
export const DISTANCE_BREAK_THERSHOLD = 1000
export const NUMBER_OF_CLUSTERS = 2
export type ThresholdType = 'percent' | 'distance'

export const isExceedPercentThreshold = (datum: Datum, chartConfig: ChartConfig) => {
  const { value: total } = chartConfig
  const { value } = datum
  if (!isNumber(value) || !isNumber(total)) {
    return false
  }

  const percent = value / total
  return percent > PERCENT_BREAK_THRESHOLD
}

export const isExceedDistanceThreshold = (values: number[]) => {
  if (isOnlyOneNonZeroValue(values)) return { isExceedThreshold: false }

  const max = Math.max(...values)
  const min = Math.min(...values)
  const isExceedThreshold = max - min > DISTANCE_BREAK_THERSHOLD
  if (!isExceedThreshold) return { isExceedThreshold: false }

  return { isExceedThreshold: true, isInLargeCluster: getIsInLargeCluster(values) }
}

export const isOnlyOneNonZeroValue = (values: number[]) =>
  values.filter((v) => v !== 0).length === 1

const getIsInLargeCluster = (values: number[]) => {
  const clusters = kmeans(values, NUMBER_OF_CLUSTERS)
  if (clusters.length < 2) {
    return () => false
  }

  const [, largeCluster] = clusters
  const minOfLarge = largeCluster[0]
  const maxOfLarge = largeCluster[largeCluster.length - 1]

  const isInLargeCluster = (value: Datum['value']) => {
    if (!isValidNumber(value)) return false
    return value >= minOfLarge && value <= maxOfLarge
  }
  return isInLargeCluster
}
